import { omit } from 'lodash'
import React from 'react'

export const TdCell = (props: any) => {
  // onMouseEnter, onMouseLeave在数据量多的时候，会严重阻塞表格单元格渲染，严重影响性能
  return <td {...omit(props, ['onMouseEnter', 'onMouseLeave'])} />
}
